// Login.tsx
import React, { useState } from "react";
import { Form } from "antd";
import { FormContainer, LoginWrapper, FormTitle, FormInput, SubmitButton, ForgotPasswordLink, FormItem, InputLabel } from "./styles";
import { useAppDispatch } from "../../utils/hooks/redux";
import SystemPayRoutes from "../../utils/constants/Routes";
import { EyeOutlined, EyeInvisibleOutlined } from "@ant-design/icons";
import { useNavigate } from "react-router-dom";
import { signInThunkAsync } from "../../redux/features/auth/authAsyncThunk";
import { ReactComponent as Concierge } from "../../assets/images/Concierge.svg";

const Login: React.FC = () => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [formData, setFormData] = useState({ email: "", password: "" });
  const [isPasswordVisible, setIsPasswordVisible] = useState(false);
  const dispatch = useAppDispatch();
  const navigate = useNavigate();

  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({ ...prevData, [name]: value }));
  };

  const handleLogin = async () => {
    if (!formData?.email || !formData.password) {
      return false;
    }
    setError("");
    setLoading(true);

    try {
      await dispatch(signInThunkAsync({ email: formData.email, password: formData.password })).unwrap();
    } catch (err: any) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  // Handle form errors
  const onFinishFailed = () => {
    // message.error("Please fill in all required fields!");
  };

  return (
    <LoginWrapper>
      <Concierge className="logoIcon" style={{ height: 48, width: "auto", marginBottom: "15px" }} />
      <FormContainer>
        <FormTitle level={3}>Sign in to your account</FormTitle>

        <Form name="login" onFinish={handleLogin} onFinishFailed={onFinishFailed}>
          {/* Email Input */}
          <InputLabel>Your email</InputLabel>
          <FormItem name="email" required rules={[{ required: true, message: "Please enter your email address!" }]} normalize={(value) => value?.trim().toLowerCase() || ""}>
            <FormInput name="email" placeholder="Email address" size="large" value={formData.email} onChange={handleInputChange} />
          </FormItem>

          {/* Password Input with Show/Hide Eye Icon */}
          <InputLabel>Password</InputLabel>
          <FormItem name="password" required rules={[{ required: true, message: "Please enter your password!" }]}>
            <FormInput
              name="password"
              placeholder="Password"
              type={isPasswordVisible ? "text" : "password"} // Toggle between 'text' and 'password'
              size="large"
              value={formData.password}
              onChange={handleInputChange}
              suffix={isPasswordVisible ? <EyeInvisibleOutlined onClick={() => setIsPasswordVisible(false)} /> : <EyeOutlined onClick={() => setIsPasswordVisible(true)} />}
            />
          </FormItem>

          {/* Forgot Password Link */}
          <ForgotPasswordLink onClick={() => navigate(SystemPayRoutes.forgotPassword)}>Forgot Password?</ForgotPasswordLink>

          {/* Login Button */}
          <SubmitButton type="primary" htmlType="submit" loading={loading}>
            Login
          </SubmitButton>
        </Form>
      </FormContainer>
    </LoginWrapper>
  );
};

export default Login;
